function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M77.58 99.75l54.1-82.73c1.17-1.74 2.09-3.24 2.09-5.28A7.74 7.74 0 00126 4c-3.26 0-5.31 2.09-7.18 4.86l-53 67.21-13.42 17-32.66-28.4c-1.86-1.87-4.12-3.37-6.94-3.37A8.84 8.84 0 004 70.16a9.3 9.3 0 001.88 6l.81 1 40 44.21c2.14 2.52 4.66 5.15 8.29 5.15 4 0 6.6-3.14 8.73-6.18l13.91-20.53"
});

var SvgTickOutline = function SvgTickOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 137.77 130.46",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgTickOutline;